import { baseComponents, common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;
function loginByQQ(loginManager) {
  loginManager.mobileLoginByQQConnect({
    appId: '101478665',
    redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: location.href,
  });

  localStorage.curPlatform = 'qq';
}

function loginByWx(loginManager) {
  loginManager.mobileLoginByWX({
    appId: 'wx5a3bbeac0d87c75a',
    scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
    userinfoSpan: 'userinfo',
    forcePopup: true,
    snapShotTips: true,
    snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
  });

  localStorage.curPlatform = 'wx';
}
export default class LoginApp {
  async initLogin() {
    // 因为midas只支持qc登录态,所以心悦先强制qc.
    window.iUseQQConnect = 1;
    console.log('LoginApp initLogin');
    return await new Promise((resolve) => {
      console.log('BB APP initLogin', Vue.prototype.$ast.isAPP());
      loginManagerInstance = new Vue.prototype.$miloLoginManager({
        commonParams: {
          iUseQQConnect: window.iUseQQConnect,
        },
        mobileParams: {
          oWXParams: {
            gameDomain: 'xinyue.qq.com',
            appId: 'wx5a3bbeac0d87c75a',
            scope: 'snsapi_userinfo',
          },
          oQQConnectParams: {
            appId: '101478665',
            redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
            sUrl: location.href,
          },
        },
      });
      resolve();
    });
  }

  async login(params) {
    console.log('LoginApp login|params=', params);
  }

  async checkLogin(params) {
    console.log('LoginBB App checkLogin|params=', params);
    return await new Promise((resolve) => {
      if (!Vue.prototype.$ast.isAPP()) {
        resolve({
          isLogin: false,
          userInfo: {},
        });
      }
      const acctype = common.tool.getCookie('acctype');
      // 端游仅限QQ用户参与
      const { game_type: gameType = 0 } = Vue.prototype.$actInfo || {};
      console.log('------Vue.prototype.$actInfo ', Vue.prototype.$actInfo);
      console.log('------Vue.prototype.$actInfo?.gid ', Vue.prototype.$actInfo?.gid);
      console.log('------parseInt(Vue.prototype.$actInfo?.gid, 10) ', parseInt(Vue.prototype.$actInfo?.gid, 10));
      // 命运方舟支持微信登录
      if (parseInt(Vue.prototype.$actInfo?.gid, 10) !== 251) {
        if (gameType === 1 && acctype === 'wx') {
          Vue.prototype.alert('该活动仅限QQ用户参与哦！');
          resolve({
            isLogin: false,
            userInfo: {},
          });
        }
      }

      if (location.href.indexOf('FLUSH_COOKIE=') > 0) {
        common.tool.clearAllCookie();
        let newHref = location.href;
        newHref = common.tool.delHrefParam('FLUSH_COOKIE', '', newHref);
        location.href = newHref;
      }
      loginManagerInstance.checkRealLogin().then((res) => {
        const { isLogin, userInfo } = res;
        if (userInfo) {
          userInfo.avatar = userInfo?.avatarUrl ?? userInfo?.formatUserInfo?.avatarUrl;
        }
        console.log('checkRealLogin  with $miloLoginManager userInfo =', userInfo);
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        //
        let curPlatform = localStorage?.getItem('curPlatform');
        console.log('checkRealLogin curPlatform from localStorage ', curPlatform);
        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }

        console.log('checkRealLogin curPlatform ', curPlatform);
        localStorage?.setItem('curPlatform', curPlatform);
        resolve({
          isLogin,
          userInfo,
        });
      })
        .catch((err) => {
          console.error('checkLogin Failed:', err);
          console.error('checkLogin Failed Code:', err.errCode);
          console.error('checkLogin Failed info:', err.errInfo);
          const { isQQ, isWX } = Vue.prototype.$platform;
          console.log('.isWX = ', isWX);
          console.log('.isQQ = ', isQQ);
          const { game_type: gameType = 0 } = Vue.prototype.$actInfo || {};
          //  微信在端游的时候不拉去分享
          // eslint-disable-next-line camelcase
          console.log('game_type from state= ', gameType);
          console.log('Vue.prototype.$actInfo ', Vue.prototype.$actInfo);
          // 默认端游不进行微信登录
          isQQ && loginByQQ(loginManagerInstance);
          // eslint-disable-next-line camelcase
          isWX && gameType !== 1 && loginByWx(loginManagerInstance);
          console.log('game_type =', gameType, 'game_type === 1 是端游 默认端游不进行微信登录');
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
    });
  }

  async checkRoleInfo() {
    return await new Promise(async (resolve) => {
      try {
        const ceibaGameInfo = {};
        const partition = common.tool.getQueryparams('serverId') || 0;
        const roleid = common.tool.getQueryparams('role') || common.tool.getQueryparams('roleid') || common.tool.getQueryparams('role_id') || common.tool.getQueryparams('roleId') || common.tool.getQueryparams('sRole') || common.tool.getQueryparams('sRoleId') || common.tool.getQueryparams('charac_no');
        const areaid = common.tool.getQueryparams('areaId') || 'others';
        if (roleid && areaid) {
          let device;
          if (parseInt(Vue.prototype.$actInfo?.gid, 10) === 1194) {
            switch (areaid) {
              case '1':
                device = 'android';
                break;
              case '2':
                device = 'android';
                break;
              case '3':
                device = 'ios';
                break;
              case '4':
                device = 'ios';
                break;
              default:
                device = 'others';
                break;
            }
          } else {
            switch (areaid) {
              case '1':
                device = 'ios';
                break;
              case '2':
                device = 'android';
                break;
              case '3':
                device = 'ios';
                break;
              case '4':
                device = 'android';
                break;
              default:
                device = 'others';
                break;
            }
          }
          // 命运方舟获取角色接口大区参数改造
          let partitionNew = partition;
          if (parseInt(Vue.prototype.$actInfo?.gid, 10) === 251) {
            partitionNew = parseInt(areaid, 10) * 10000 + parseInt(partition, 10);
          }
          console.log('-----partition_old ', partition);
          console.log('-----partition_new ', partitionNew);
          const roleList = await baseComponents.Apis.Role.fetch({
            game_code: Vue.prototype.$actInfo.game_code,
            partition_id: partitionNew,
            device,
          });
          const roleInfo = roleList.roles?.find((e) => {
            if (e.role_id === roleid) return true;
            if (e.game_open_id === e.role_id) return true;
            if (e.game_open_id === decodeURI(e.role_id)) return true;
            return false;
          });
          console.log('fetch roleList = ', roleInfo);
          if (roleInfo) {
            console.log('fetch current roleInfo=', roleInfo, common.tool.Base64.decode(roleInfo.partition_name), common.tool.Base64.decode(roleInfo.role_name));
            let gameAppIdNew = roleInfo.game_app_id;
            if (parseInt(Vue.prototype.$actInfo?.gid, 10) === 251) { // 命运方舟角色接口获取不到appid, 暂时写死appid
              const acctype = common.tool.getCookie('acctype');
              if (acctype === 'wx') {
                gameAppIdNew = 'wx0a71413944e4c4d0';
              } else {
                gameAppIdNew = '102037747';
              }
            }
            console.log('==========game_app_id old', roleInfo.game_app_id);
            console.log('==========game_app_id new', gameAppIdNew);
            ceibaGameInfo.plat_id = roleInfo.plat_id;
            ceibaGameInfo.partition_id = roleInfo.partition_id;
            ceibaGameInfo.role_id = roleInfo.role_id;
            ceibaGameInfo.area_id = roleInfo.area_id;
            ceibaGameInfo.device = roleInfo.device;
            ceibaGameInfo.game_open_id = roleInfo.game_open_id;
            ceibaGameInfo.game_app_id = gameAppIdNew;
            ceibaGameInfo.partition_name = roleInfo.partition_name;
            ceibaGameInfo.role_name = roleInfo.role_name;
            sessionStorage.ceibaGameInfo = JSON.stringify(ceibaGameInfo);
            console.log('sessionStorage.ceibaGameInfo=', sessionStorage.ceibaGameInfo);
            resolve({
              isRoleReady: true,
              roleInfo: ceibaGameInfo,
            });
          } else {
            resolve({
              isRoleReady: false,
              roleInfo: {},
            });
          }
        } else {
          resolve({
            defaultPlugin: true,
            isRoleReady: false,
            roleInfo: {},
          });
        }
      } catch (e) {
        console.log('checkRole fail ', e);
        const loginInvalidRet = [7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7551];
        if (loginInvalidRet.includes(e.data.ret)) {
          Vue.prototype.alert('登录态过期，请退出重新登录！');
        }
        return {
          isRoleReady: false,
          roleInfo: {},
        };
      }
    });
  }

  async logout(params) {
    // app内,web禁止登出
    console.log('LoginApp logout|param=', params);
  }
}
